"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addElementEventListener = addElementEventListener;
exports.addElementResizeListener = addElementResizeListener;
exports.addEventListener = addEventListener;
exports.keyDownEnter = keyDownEnter;
var _elementResizeEvent = _interopRequireDefault(require("./element-resize-event"));
var _data = require("../data");
var _typeof = require("../data/typeof");
/**
 * 在 element 上绑定事件，并返回取消绑定的函数
 * @param  {HTMLElement} el
 * @param  {...any} args
 */
function addElementEventListener(el) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (!el) return null;
  // @ts-ignore
  el.addEventListener.apply(el, args);
  return function () {
    if (!el) return;
    // @ts-ignore
    el.removeEventListener.apply(el, args);
  };
}
/**
 * 在 window 上绑定事件，并返回取消绑定的函数
 * @param  {...any} args
 */
function addEventListener() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return addElementEventListener.apply(void 0, [window].concat(args));
}
/**
 * 给 element 绑定监听 resize 事件，并返回取消绑定的函数
 * @param  {...any} args
 */
function addElementResizeListener() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  if (!args[0]) return _data.noop;
  _elementResizeEvent.default.apply(void 0, args);
  return function () {
    _elementResizeEvent.default.unbind.apply(_elementResizeEvent.default, args);
  };
}
/**
 * 在敲击 enter 键时执行 fn
 * @param {Function} fn
 */
function keyDownEnter(fn) {
  return function (e) {
    if (!e || !(0, _typeof.isObject)(e) || !(0, _typeof.isFunction)(fn)) return;
    if (e.keyCode === _data.KEYCODE.ENTER) {
      fn(e);
    }
  };
}